import { useLocation, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
// config
import { BOTTOM_NAV } from '../../config';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const NAV_ITEMS = [
  { label: 'Bosh sahifa', path: '/dashboard/home', icon: 'solar:home-2-bold' },
  { label: 'Mavzular', path: '/dashboard/topics', icon: 'solar:book-bookmark-bold' },
  { label: 'Ekspertlar', path: '/dashboard/experts', icon: 'solar:users-group-rounded-bold' },
  { label: 'Reyting', path: '/dashboard/rating', icon: 'solar:cup-star-bold' },
  { label: 'Profil', path: '/dashboard/profile', icon: 'solar:user-bold' },
];

const RootStyle = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.appBar,
  borderTop: `1px solid ${theme.palette.divider}`,
}));

// ----------------------------------------------------------------------

export default function BottomNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const currentIndex = NAV_ITEMS.findIndex((item) => pathname.startsWith(item.path));

  return (
    <RootStyle elevation={3}>
      <BottomNavigation
        showLabels
        value={currentIndex === -1 ? 0 : currentIndex}
        onChange={(_, newValue) => {
          navigate(NAV_ITEMS[newValue].path);
        }}
        sx={{
          height: BOTTOM_NAV.HEIGHT,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            padding: '6px 4px 8px',
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: 10,
            lineHeight: 1.1,
            mt: 0.25,
            whiteSpace: 'nowrap',
            '&.Mui-selected': { fontSize: 11 },
          },
        }}
      >
        {NAV_ITEMS.map((item) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            icon={<Iconify icon={item.icon} width={22} height={22} />}
          />
        ))}
      </BottomNavigation>
    </RootStyle>
  );
}
